<div id="tpid"></div>
<div class="body">
    <div class="new-cont" *ngIf='noticiaElegida'>
        <div class="new-title">
            <p>{{noticiaElegida.title}}</p>
        </div>
        <div class="row m-0">
            <div class="col-lg-9 p-0">
                <div class="img-cont">
                    <img src="{{noticiaElegida.image}}">
                </div>
                <div class="text-cont">
                    <div class="contenedor-titulo">
                        <p> Fuente: {{ noticiaElegida.source }} </p>
                        <p>
                            Cochabamba,
                            {{noticiaElegida.dateOfNew.toDate().getDate()}}/{{noticiaElegida.dateOfNew.toDate().getMonth() + 1}}/{{noticiaElegida.dateOfNew.toDate().getFullYear()}}
                        </p>
                        <p>{{noticiaElegida.category.name}}</p>
                    </div>
                    <div *ngIf='noticiaElegida.contentNew' class="contenedor-noticia" [innerHTML]="noticiaElegida.contentNew | safeHtml"> </div>
                    <div *ngIf='!noticiaElegida.contentNew' class="contenedor-noticia" >{{noticiaElegida.description}} </div>

                    <div class="btnEnd">
                        <a target="_blank" href="{{base}}" (click)="toFb(noticiaElegida)" id="facebook-Link">
                            <button mat-stroked-button class="btn-primaryfb">
                                <div class="fb-share-button" [attr.data-href]="base2" data-layout="button"
                                    data-size="small">
                                    <i class="fa fa-facebook-square" style="font-size:35px;color:#3B5998"></i>
                                </div>
                            </button>
                        </a>
                    </div>
                    <div class="btnBack">
                        <button mat-mini-fab color="warn" routerLink="/noticias">
                            <mat-icon class="colorPublish">reply</mat-icon>
                        </button>
                    </div>
    
                    <div class="btnTop">
                        <button mat-mini-fab color="warn" (click)="ScrollTo()">
                            <mat-icon class="colorPublish">keyboard_arrow_up</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 p-0">
                <div class="sugest-list">
                    <div class="tituloCat">SUGERENCIAS</div>
                    <mat-list role="list" class="sugerencias">
                        <mat-list-item role="listitem" class="sugerencias-image" *ngFor="let element of datasourcenew"
                                infinite-scroll
                                [infiniteScrollDistance]="0.5"
                                [infiniteScrollThrottle]="50"
                                [infiniteScrollContainer]="selector"
                                [fromRoot]="true"
                                [infiniteScrollDisabled]="disabledScroll"
                                (scrolled)="llenarDataSourceNew()">
                            <div class="contenedor-image-centrar">
                                <img class="col-12 p-0" src="{{element.image}}" alt="">
                                <div class="centrear-image-sugerencias">
                                    <div class="contenedor-texto-sugerencias"
                                        [ngClass]="{'contenedor-texto-sugerenciasB': noticiaElegida.id == element.id }"
                                        (click)="cambiar(element.id)">
                                        <div class="centrear-texto-sugerencias">
                                            <p>{{element.autor | truncate:'65'}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-list-item>
                    </mat-list>
                </div>
                <div class="sugest-slides">
                    <div class="titulo-categorias">
                        <h3>Sugerencias</h3>
                    </div>
                    <div class="contenedor-principal">
                        <app-sugest-slider style="width: 100%" [noticias]="datasourcenew" (openNotiSel)="cambiar($event)" (llenarDatos)="llenarDataSourceNew()">
                        </app-sugest-slider>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="publicidad">
        <div class="contenedor-publicidad">
            <div class="contenedor-texto-publicidad">
                <app-publicidad></app-publicidad>
            </div>
        </div>
    </div>

    <footer>
        <app-footer-new></app-footer-new>
    </footer>
</div>